export default __webpack_public_path__ + "static/media/img_15.42b4103c.JPG";